import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FaEnvelope, FaLink, FaPhone, FaFax, FaClock } from "react-icons/fa";

const InstitutionDetailsInner = props => {
  const { institution: i, showAll, onSearchTag = () => {} } = props;
  const { phone, fax, email, contact_person } = i.contact || {};
  const { street, zipcode, city } = i.address || {};

  const shorten = (text, max) =>
    text.length <= max ? text : text.slice(0, max) + "…";

  return (
    <div>
      {showAll ? (
        <h1 className={`${!i.approved ? "unapproved" : ""}`}>{i.name}</h1>
      ) : (
        <h2 className={`${!i.approved ? "unapproved" : ""}`}>{i.name}</h2>
      )}
      <div className="leaflet-inner">
        {i.offborders === 2 && (
          <p>
            <em>Stadtweites Angebot</em>
          </p>
        )}
        {i.offborders === 1 && (
          <p>
            <em>Bezirksweites Angebot</em>
          </p>
        )}
        <div className="contactline">
          <div>
            {street}
            <br />
            {zipcode} {city}
            <br />
          </div>
        </div>
        <div className="contactline">
          {Boolean(email) &&
            email.split(",").map(address => {
              return (
                <div>
                  <FaEnvelope />{" "}
                  <a key={address} href={`mailto:${address.trim()}`}>
                    {address.trim()}
                  </a>
                </div>
              );
            })}
          {Boolean(i.url) && (
            <div title="Webseite">
              <FaLink />{" "}
              <a target="_blank" href={`${i.url}`}>
                {shorten(i.url, 40)}
              </a>
            </div>
          )}
          {Boolean(phone) && (
            <div title="Telefon">
              {Boolean(phone) && (
                <span>
                  <FaPhone /> <a href={`tel://${phone}`}>{phone}</a>
                </span>
              )}
              {contact_person ? ` (${contact_person})` : null}
            </div>
          )}
          {Boolean(fax) && (
            <div title="Fax">
              <FaFax /> {fax}
            </div>
          )}
          {Boolean(i.opening_hours) && (
            <div title="Öffnungszeiten">
              <FaClock /> {i.opening_hours}
            </div>
          )}
          {Boolean(i.description) && showAll && (
            <blockquote>
              {i.description.split("\n").map(function(item, key) {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </blockquote>
          )}
          <div>
            {(i.tags || []).map(tag => {
              return (
                <button
                  onClick={() => onSearchTag(tag)}
                  key={tag}
                  className="tag is-primary is-small"
                >
                  {tag}&nbsp;
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

InstitutionDetailsInner.defaultProps = {
  showAll: true
};

InstitutionDetailsInner.propTypes = {
  institution: PropTypes.object,
  showAll: PropTypes.bool
};

export default InstitutionDetailsInner;



/** WEBPACK FOOTER **
 ** ./src/components/InstitutionDetailsInner.jsx
 **/